'use strict';
/**
 * Entry composing the partial view of a peer.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var EPV =
/*#__PURE__*/
function () {
  /**
     * @param {string} peerId The identifier of the neighbor.
     * @param {object} [descriptor = {}] The descriptor of this neighbor.
     */
  function EPV(peerId) {
    var descriptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, EPV);

    this.peer = peerId;
    this.ages = [0];
    this.descriptor = descriptor;
  }
  /**
     * Update the descriptor of the entry
     * @param {object} descriptor The new descriptor assigned to this neigbhor.
     */


  _createClass(EPV, [{
    key: "update",
    value: function update(descriptor) {
      this.descriptor = descriptor;
    }
    /**
       * Increment the ages
       */

  }, {
    key: "increment",
    value: function increment() {
      this.ages = this.ages.map(function (age) {
        return age + 1;
      });
    }
    /**
       * Add a new 'instance' of this neigbhor, i.e., add a new age entry.
       */

  }, {
    key: "add",
    value: function add() {
      this.ages.unshift(0);
    }
    /**
       * Remove the oldest entry of this neighbor.
       * @returns {boolean} True if the entry has no age anymore, false otherwise.
       */

  }, {
    key: "removeOldest",
    value: function removeOldest() {
      this.ages.pop();
      return this.ages.length === 0;
    }
    /**
       * Remove the youngest entry of this neigbhor.
       * @returns {boolean} True if the entry has no age anymore, false otherwise.
       */

  }, {
    key: "removeYoungest",
    value: function removeYoungest() {
      this.ages.shift();
      return this.ages.length === 0;
    }
    /**
       * Get the oldest age of this neighbor.
       * @returns {number} The oldest age.
       */

  }, {
    key: "oldest",
    get: function get() {
      return this.ages[this.ages.length - 1];
    }
    /**
       * Get the number of occurrences of this neighbor.
       */

  }, {
    key: "count",
    get: function get() {
      return this.ages.length;
    }
  }]);

  return EPV;
}();

module.exports = EPV;